import { CoreModel } from '../core/core.model';
export class SidenavModel extends CoreModel {
/**
 * <b>ng-template id (#)</b> inside component tags to be used as html for sidenav content section
 */
contentId?: string;
/**
 * <b>ng-template id (#)</b> inside component tags to be used as html for sidenav left side
 */
leftSideId?: string;
/**
 * <b>ng-template id (#)</b> inside component tags to be used as html for sidenav right side
 */
rightSideId?: string;
/**
 * Opening mode. Can be: over, push, side
 */
leftSideMode?: string;
/**
 * Opening mode. Can be: over, push, side
 */
rightSideMode?: string;
/**
 * If the sidenav must take height of parent container
 */
fullHeight?: boolean;
/**
 * Width of left side
 */
leftSideWidth?: string;
/**
 * Width of right side
 */
rightSideWidth?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function SidenavModel_tsickle_Closure_declarations() {
/**
 * <b>ng-template id (#)</b> inside component tags to be used as html for sidenav content section
 * @type {?}
 */
SidenavModel.prototype.contentId;
/**
 * <b>ng-template id (#)</b> inside component tags to be used as html for sidenav left side
 * @type {?}
 */
SidenavModel.prototype.leftSideId;
/**
 * <b>ng-template id (#)</b> inside component tags to be used as html for sidenav right side
 * @type {?}
 */
SidenavModel.prototype.rightSideId;
/**
 * Opening mode. Can be: over, push, side
 * @type {?}
 */
SidenavModel.prototype.leftSideMode;
/**
 * Opening mode. Can be: over, push, side
 * @type {?}
 */
SidenavModel.prototype.rightSideMode;
/**
 * If the sidenav must take height of parent container
 * @type {?}
 */
SidenavModel.prototype.fullHeight;
/**
 * Width of left side
 * @type {?}
 */
SidenavModel.prototype.leftSideWidth;
/**
 * Width of right side
 * @type {?}
 */
SidenavModel.prototype.rightSideWidth;
}

